import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  TextField,
} from '@mui/material';
import { useState } from 'react';
import { LoadingButton } from '@/components/shared/LoadingButton';
import { useSnackBarMessage } from '@/utils/useSnackBarMessage';
import { useGetStructureId } from '@/hooks/useGetStructureId';
import { theme } from '@/theme/theme';
import { GetPointOfInterestGroupedByWorkpackDocument, useUpdateWorkpackMutation } from '@/__generated__/graphql';

type EditWorkpackDialogProps = {
  isOpen: boolean;
  title: string;
  selectedWorkpackId: string;
  selectedWorkpackName: string;
  handleClose: () => void;
};

export const EditWorkpackDialog = ({
  isOpen,
  title,
  selectedWorkpackId,
  selectedWorkpackName,
  handleClose,
}: EditWorkpackDialogProps) => {
  const [workpackName, setWorkpackName] = useState<string>(selectedWorkpackName);
  const { showSnackBar } = useSnackBarMessage({ variant: 'filled' });
  const structureId = useGetStructureId();

  const [updateWorkpack, { loading }] = useUpdateWorkpackMutation();

  const handleUpdateWorkpack = () => {
    updateWorkpack({
      variables: {
        input: {
          workpackId: selectedWorkpackId,
          name: workpackName,
          structureId,
        },
      },
      onCompleted: () => {
        handleClose();
        showSnackBar('Workpack has been updated successfully', 'success');
      },
      onError: (error) => {
        handleClose();
        showSnackBar(`${error.message}`, 'error');
      },
      refetchQueries: [GetPointOfInterestGroupedByWorkpackDocument],
    });
  };

  return (
    <Dialog open={isOpen} maxWidth="sm" fullWidth sx={{ radius: 2 }}>
      <DialogTitle sx={{ m: 0, p: 2 }}>{title}</DialogTitle>
      <IconButton
        aria-label="close"
        onClick={handleClose}
        sx={{ position: 'absolute', right: 8, top: 8, color: theme.palette.grey[500] }}
      >
        <CloseIcon />
      </IconButton>
      <DialogContent>
        <TextField
          fullWidth
          label="Workpack name"
          variant="standard"
          value={workpackName}
          onChange={(event) => setWorkpackName(event?.target.value)}
        />
      </DialogContent>
      <Divider />
      <Divider orientation="horizontal" />
      <DialogActions>
        <Button onClick={handleClose} color="primary" size="large">
          Cancel
        </Button>
        <LoadingButton onClick={handleUpdateWorkpack} loading={loading}>
          Update
        </LoadingButton>
      </DialogActions>
    </Dialog>
  );
};
